import * as React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as ReqType from '../../../types/ServerRequests';
import { Redirect } from 'react-router';

interface Props {
    event: ReqType.Event;
}

interface State {
    redirect: boolean;
}

/**
 * Ce composant permet l'affichage d'une ligne d'event
 */
export class LigneEvent extends React.Component {
    state: State;
    props: Props;

    constructor(props: Props) {
        super(props);
        this.state = {
            redirect: false,
        };
    }

    onClick = () => {
        this.setState({ redirect: true });
    }

    render() {
        const divStyle = {
            cursor: 'pointer'
        };
        if (this.state.redirect) {
            return <Redirect to={'/schedule/' + this.props.event.id} />;
        } else {
            return (
                <tr
                    key={this.props.event.id}
                    onClick={() => {
                        this.onClick();
                    }}
                    style={divStyle}
                >
                    <td scope="row">{this.props.event.id}</td>
                    <td scope="row">{this.props.event.intitule}</td>
                    <td scope="row">{this.props.event.description}</td>
                </tr>
            );
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/ProfilePage/internalComponents/LigneEvent.tsx